import { Controller } from "@hotwired/stimulus"
import { template } from "lodash"
export default class extends Controller {
  static targets = ["newDescriptionTemplate", "list", "listWrapper", "addButton", "content", "showPositionIndexBtn",
    "hidePositionIndexBtn", "positionIndexWrapper"]

  static values = {
    index: { type: Number, default: 0 },
    defaultKind: String,
    positionIndexVisible: { type: Boolean, default: false },
  }

  newDescriptionTemplate

  connect() {
    if (this.hasNewDescriptionTemplateTarget) {
      this.newDescriptionTemplate = template(this.newDescriptionTemplateTarget.innerHTML)
    }
    this.updateVisibility()
    window.addEventListener("department-changed", this.updateAdditionalDescription.bind(this))
  }

  add() {
    if (!this.hasNewDescriptionTemplateTarget || !this.hasListTarget) return

    const newDescription = this.newDescriptionTemplate({
      index: parseInt(this.indexValue)
    })
    this.listTarget.insertAdjacentHTML("beforeend", newDescription)
    this.indexValue += 1
    this.updateVisibility()
    //TODO dodac sortowanie
  }

  showPositionIndex() {
    this.positionIndexVisibleValue = true
  }

  hidePositionIndex() {
    this.positionIndexVisibleValue = false
  }

  positionIndexVisibleValueChanged(visible) {
    this.positionIndexWrapperTargets
      .forEach(el => el.classList.toggle("hidden", !visible))

    if (this.hasShowPositionIndexBtnTarget) this.showPositionIndexBtnTarget.classList.toggle("hidden", visible)
    if (this.hasHidePositionIndexBtnTarget) this.hidePositionIndexBtnTarget.classList.toggle("hidden", !visible)
  }

  updateAdditionalDescription(event) {
    // Aktualizacja pierwszego wiersza additional_descriptions przy zmianie działu
    // Priorytet: department description → account description → existing content

    const content = event.detail.content || ""

    let contentElems = this.contentTargets
    // Jeśli nie ma żadnych wierszy, dodaj nowy
    if (contentElems.length === 0) {
      this.add()
      contentElems = this.contentTargets
    }

    requestAnimationFrame(() => {
      const firstElem = contentElems[0]

      firstElem.dispatchEvent(new CustomEvent("additional-descriptions:update-description", {
        bubbles: true,
        detail: { position_index: "", kind: this.defaultKindValue, content }
      }))
    })
  }

  positionIndexWrapperTargetConnected(element) {
    element.classList.toggle("hidden", !this.positionIndexVisibleValue)
  }

  updatePositionVisibilityButtons(visibleContent = this.visibleContentTargets()) {
    if (visibleContent.length === 0) {
      this.showPositionIndexBtnTarget.classList.add("hidden")
      this.hidePositionIndexBtnTarget.classList.add("hidden")
    } else {
      this.positionIndexVisibleValueChanged(this.positionIndexVisibleValue)
    }
  }

  visibleContentTargets() {
    return this.contentTargets.filter(target => !target.classList.contains("hidden"))
  }

  updateVisibility() {
    const visibleContent = this.visibleContentTargets()

    if (this.hasListWrapperTarget) this.listWrapperTarget.classList.toggle("hidden", visibleContent.length === 0)
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.toggle("hidden", visibleContent.length > 0)

    visibleContent.forEach((content, index) => content.classList.toggle("is-first", index === 0))

    this.updatePositionVisibilityButtons(visibleContent)
  }
}
